<template>
  <div>
    <template v-if="data">
      <v-toolbar flat dense class="sticky_solutionSelector">
        <v-toolbar-title>{{data.Name}}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn
          class="mr-2"
          v-on:click="useInMarker()"
          small
          depressed
          outlined
          color="secondary"
        >{{$t('usethisinmarker')}}</v-btn>
        <v-btn outlined small depressed v-on:click="backToSolutionList">
          <v-icon class="mr-2" small color="primary">fa-arrow-left</v-icon>
        </v-btn>
      </v-toolbar>
      <div class="main_wrapper mt-5">
        <div class="main_taxonomies">
          <div v-for="(selectedTax,i) in data.SelectedTaxonomies" :key="i">
            <template v-if="selectedTax">
              <div class="option wrapper_content_taxonomy">
                <div class="option">
                  <v-img height="70" width="70" v-if="selectedTax.Image" :src="selectedTax.Image">
                  </v-img>
                </div>
                <div class="subtitle-1 option">{{`${$t('step')} ${i + 1}: `}}{{selectedTax.Title}}
                  <div class="caption font-weight-medium">{{selectedTax.Name}}</div>
                  <div class="caption" v-html="selectedTax.Description"></div>
                </div>
                <!-- <v-img class="option" :src="tax.Image" aspect-ratio="1" height="50"></ -->
              </div>
              <v-divider v-if="i != data.SelectedTaxonomies.length -1"></v-divider>
            </template>
          </div>
        </div>
        <div class="main_images">
          <template v-if="data.Images && data.Images.length > 0">
            <zoomPicture :src="data.Images[0]" imageHeight="360"></zoomPicture>
            <!-- <v-img :src="data.Images[0]" contain height="360px"></v-img> -->
          </template>
        </div>
        <div class="main_attachments">
          <div class="subtitle-2">{{$t('download')}}</div>
          <div v-for="(attachment,i) in data.Attachments" :key="i">
            <div class="option wrapper_content_attachment">
              <div class="option">
                <v-icon color="primary">fa-file-alt</v-icon>
              </div>
              <div class="subtitle-2 option">
                <a target="_blank" :href="attachment.Link">{{attachment.Category}}</a>
                <!-- <div class="caption font-weight-medium">{{selectedTax.Name}}</div>
                <div class="caption" v-html="selectedTax.Description"></div>-->
              </div>
              <!-- <v-img class="option" :src="tax.Image" aspect-ratio="1" height="50"></ -->
            </div>
            <v-divider v-if="i != data.Attachments.length -1"></v-divider>
          </div>
        </div>
        <div class="main_products">
          <div class="subtitle-2">{{$t('products')}}</div>
          <div class="scroll-container">
            <div v-for="(product,i) in data.Products" :key="'p-'+i" class="text-truncate">
              <v-layout class="pa-2" column>
                <a target="_blank" :href="product.Link">
                  <v-img
                    gradient="to bottom, rgba(0,0,0,.1), rgba(255,255,255,.5)"
                    aspect-ratio="1"
                    width="142"
                    :src="product.Image"
                    dark
                  >
                    <v-card-actions class="fill-height align-end gradient text-truncate">
                      <span class="text-truncate d-inline-block">{{product.Name}}</span>
                    </v-card-actions>
                    <template v-slot:placeholder>
                      <v-layout fill-height align-center justify-center ma-0>
                        <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                      </v-layout>
                    </template>
                  </v-img>
                </a>
              </v-layout>
            </div>
          </div>
        </div>
        <div class="main_description">
          <div class="subtitle-2">{{$t('description')}}</div>
          <div v-html="data.Description"></div>
        </div>
        <div class="main_application">
          <div class="subtitle-2">{{$t('application')}}</div>
          <div v-html="data.Application"></div>
        </div>
      </div>
    </template>
    <v-container class="main_wrapper mt-5" v-else>
      <div v-if="error" class="title mt -6 text-center overline mx-auto">{{$t('error')}}</div>
      <template v-else>
        <v-skeleton-loader type="article"></v-skeleton-loader>
        <v-skeleton-loader type="image"></v-skeleton-loader>
        <v-skeleton-loader type="list-item-three-line"></v-skeleton-loader>
        <v-skeleton-loader type="list-item-three-line"></v-skeleton-loader>
      </template>
    </v-container>
  </div>
</template>

<script>
import ajax from "@/services/service.oryx.js";
import jwtdecode from "jwt-decode";
import zoomPicture from "@/components/pages/Markers/ZoomPicture";
export default {
  name: "selectedSolutionComponent",
  components:{
    zoomPicture
  },
  props: {
    id: String,
    taxId: String
  },
  data() {
    return {
      data: null,
      loading: false,
      error: false
    };
  },
  created() {
    this.getSelectedSolution();
  },
  methods: {
    backToSolutionList() {
      //send message to parent to clear selected solution
      this.$emit("back");
    },
    useInMarker() {
      let taxonomies = this.data.SelectedTaxonomies.filter(x => x !== null).map(x => x.Id);
      this.$emit("useInMarkerFromDetails", {
        solution: this.data,
        taxonomies: taxonomies
      });
    },
    getSelectedSolution() {
      const params = {
        solutionId: this.id,
        tax263415Id: this.taxId,
        companyId: jwtdecode(localStorage.getItem("auth")).companyId,
        lc: localStorage.getItem("language")
      };

      ajax
        .getSelectedSolution(params)
        .then(res => {
          this.data = res.data;
          this.loading = false;
        })
        .catch(err => {
          console.log(err);
          this.loading = false;
          this.error = true;
        });
    }
  }
};
</script>
<style scoped>
.main_wrapper {
  --auto-grid-min-size: 25rem;
  display: grid;
  grid-gap: 1em;

  grid-template-columns: minmax(var(--auto-grid-min-size), 3fr 1fr);
  grid-template-areas: 'taxonomies images'
                        'application products'
                        'attachments description';
  grid-auto-flow: dense; /* NEW */
}
@media (min-width: 900px) {
  .main_wrapper {
    grid-template-columns: 50% 50%;
    grid-auto-flow: dense; /* NEW */
  }
}

@media (max-width: 768px) {
  
  .main_wrapper {
  --auto-grid-min-size: 25rem;
  display: grid;
  grid-gap: .2em;

  grid-template-areas: 'images'
                        'application'
                        'taxonomies'
                        'products'
                        'attachments'
                        'description';
  grid-auto-flow: dense; /* NEW */
}
  
}

.main_wrapper > div {
  padding: .2em;
}
.wrapper_content_taxonomy {
  display: grid;
  grid-template-columns: 1fr 3fr;
}
.wrapper_content_attachment {
  display: grid;
  grid-template-columns: 1fr 3fr;
}
.option {
  border-radius: 5px;
  padding: 5px;
  height: auto;
}
.scroll-container {
  display: flex;
  overflow: auto;
  flex: none;
  scroll-snap-type: x mandatory;
}
.main_products {
  overflow: auto;
  grid-area: products
}
.main_application{
  grid-area: application
}

.main_attachments{
  grid-area: attachments
}
.main_taxonomies{
  grid-area: taxonomies
}
.main_images {
  overflow: hidden;
  grid-area: images
}
.main_description{
  grid-area: description
}
.scroll-container > div {
  text-align: center;
  scroll-snap-align: center;
  flex: none;
}
.sticky_solutionSelector {
  position: -webkit-sticky !important;
  position: sticky !important;
  z-index: 4;
  border-bottom: 1px solid rgba(0, 0, 0, 0.12) !important;
}
</style>


// WEBPACK FOOTER //
// src/components/pages/Markers/SolutionSelector/Detail.vue